import { getCurrentUnitSystem, L, UNITS } from 'harmony-language';
import { kgToPounds, kmphToMetersPerSecond, metersPerSecondToKMPH, metersPerSecondToMPH, mphToMetersPerSecond } from '../../../utils/unit-conversion';

export const useConvertedUnitWeight = (weight = 0): { result: number, unitTranslation: string } => {
    const isMetric = getCurrentUnitSystem() === UNITS.Metric;
    const unitTranslation = isMetric ? L.unitsMetricWeightAbbr() : L.unitsImperialWeightAbbr();
    const result = Math.round((isMetric ? weight : kgToPounds(weight)) * 100) / 100;

    return {
        result,
        unitTranslation
    };
};

export const useConvertedUnitSpeed = () => {
    function metersPerSecondToLocalized(speed = 0) {
        return Math.round((isMetric ? metersPerSecondToKMPH(speed) : metersPerSecondToMPH(speed)) * 100) / 100;
    }
    function localizedToMetersPerSecond(speed = 0, precision = 0) {
        const metersPerSecond = isMetric ? kmphToMetersPerSecond(speed) : mphToMetersPerSecond(speed);
        return Number(metersPerSecond.toFixed(precision));
    }
    const isMetric = getCurrentUnitSystem() === UNITS.Metric;
    const unitTranslation = isMetric ? L.unitsMetricSpeedAbbr() : L.unitsImperialSpeedAbbr();

    return {
        metersPerSecondToLocalized,
        localizedToMetersPerSecond,
        unitTranslation
    };
};
